import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberInvitationLinkValidity } from '../../utils/keys';
export const useValidateLink = (options) => {
    const { useQueryOptions, variables } = options || {};
    const { client } = useTribeClient();
    const memberInvitationLinkValidityKey = getMemberInvitationLinkValidity(variables.id);
    return useQuery(memberInvitationLinkValidityKey, () => client.invitations.validateLink(variables), useQueryOptions);
};
//# sourceMappingURL=useValidateLink.js.map